import { SiteType } from '~/utilities/graphql/codegen';

export type GalleryLayout = {
  /** Space between gallery items */
  gap: string;
  /** Outer padding around the grid */
  padding: string;
  /** Item width in a two-column row — must leave room for `gap` */
  columnWidth: string;
};

const DEFAULT_LAYOUT: GalleryLayout = {
  gap: '1px',
  padding: '0px',
  columnWidth: 'calc(50% - 1px)',
};

export const GALLERY_LAYOUT: Record<SiteType, GalleryLayout> = {
  [SiteType.Gstar]: DEFAULT_LAYOUT,
  [SiteType.Outlet]: DEFAULT_LAYOUT,
  [SiteType.Employeeshop]: DEFAULT_LAYOUT,
  [SiteType.Aaf]: { gap: '2px', padding: '0px', columnWidth: 'calc(50% - 1px)' },
  [SiteType.Wahts]: { gap: '4px', padding: '4px', columnWidth: 'calc(50% - 2px)' },
};
